import React, { bindActionCreators } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Immutable, { Map } from "immutable";

import { resetVotingForm } from "data/voting-form";

import { toggleModal } from "data/voting-form/routes";

import { setParentSection } from "data/voting-form/parent-section";

import { getEntity, getEntityId } from "data/entity";

import { getImage } from "data/assets";

import VotingModal from "./VotingModal";

class App extends React.PureComponent {
  state = {
    isModalOpen: false,
  };

  launchModal = () => {
    const { autoLaunchOn, toggleModal } = this.props;

    if (typeof autoLaunchOn === "function" && autoLaunchOn()) {
      toggleModal(true);

      this.setState({
        isModalOpen: true,
      });

      window.location.hash = "";
    }
  };

  handleHashChange = () => {
    const { listenToHashChange } = this.props;

    if (listenToHashChange) {
      this.launchModal();
    }
  };

  componentWillUpdate(nextProps, nextState) {
    const { launchLocation, entityName, entityId } = this.props;

    if (!this.state.isModalOpen && nextState.isModalOpen) {
      window &&
        window.SnapAnalytics &&
        window.SnapAnalytics.track({
          hitType: "event",
          eventCategory: "voting form",
          eventLabel: launchLocation,
          eventAction: "open",
        });
    }
  }

  componentDidMount() {
    this.launchModal();

    window.addEventListener("hashchange", this.handleHashChange);
  }

  componentWillUnmount() {
    window.removeEventListener("hashchange", this.handleHashChange);

    window.SnapAnalytics && window.SnapAnalytics.clear();
  }

  handleModalOpen = () => {
    const { preSelectCampaignToVoteFor } = this.props;
    const { selectParentCampaign, setCurrentPage, toggleModal } = this.props;

    toggleModal(true);

    this.setState({
      isModalOpen: true,
    });
  };

  handleClick = (e) => {
    const { section, setParentSection } = this.props;

    setParentSection(section);

    e.preventDefault();

    this.handleModalOpen();
  };

  handleClose = (e) => {
    const { toggleModal, onClose, resetVotingForm } = this.props;

    toggleModal(false);
    this.setState({
      isModalOpen: false,
    });

    resetVotingForm();
    if (typeof onClose === "function") {
      onClose();
    }
  };

  renderContent() {
    const { children, markup, likePlus } = this.props;

    if (markup) {
      return (
        <div onClick={this.handleClick} dangerouslySetInnerHTML={{ __html: markup }} />
      );
    } else if (children) {
      return <div onClick={this.handleClick}>{children}</div>;
    }

    return (
      <button
        data-testid="t-voting-form--App-button"
        className="vote-btn primary-color-background"
        onClick={this.handleClick}>
        <img className="like" src={likePlus} />
        Give & Vote
      </button>
    );
  }

  render() {
    const { isModalOpen } = this.state;
    const { entity, preSelectCampaignToVoteFor, trackGiveButtonEvent } = this.props;

    return (
      <div className="inline-b">
        <VotingModal
          entity={entity}
          isModalOpen={isModalOpen}
          closeModal={this.handleClose}
          preSelectCampaignToVoteFor={preSelectCampaignToVoteFor}
          trackGiveButtonEvent={trackGiveButtonEvent}
        />
        {this.renderContent()}
      </div>
    );
  }
}

App.propTypes = {
  entityId: PropTypes.string,
  sectionId: PropTypes.string,

  markup: PropTypes.string,
  autoLaunchOn: PropTypes.func,
  listenToHashChange: PropTypes.bool,

  // if launched from tiles or leaderboard, optional way to preselect campaign
  // to vote for
  preSelectCampaignToVoteFor: PropTypes.instanceOf(Map),

  resetVotingForm: PropTypes.func.isRequired,
  setParentSection: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    entity: getEntity(state),
    entityId: getEntityId(state),
    likePlus: getImage(state, "like_plus"),
  };
};

const mapDispatchToProps = {
  resetVotingForm,
  setParentSection,
  toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
